import { useLocalStorage } from "@src/appV2/lib/utils/useLocalstorage";
import constate from "constate";
import { useCallback } from "react";

export type ThemeMode = "light" | "dark";

const THEME_MODE_STORAGE_KEY = "cbh-admin:themeMode";

function getSystemThemeMode(): ThemeMode {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return "light";
  }
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

function useUserPreferencesState() {
  const [themeMode, setThemeMode] = useLocalStorage<ThemeMode>(
    THEME_MODE_STORAGE_KEY,
    getSystemThemeMode
  );

  const toggleThemeMode = useCallback(() => {
    setThemeMode((current) => (current === "dark" ? "light" : "dark"));
  }, [setThemeMode]);

  return { themeMode, setThemeMode, toggleThemeMode };
}

export const [UserPreferencesProvider, useUserPreferences] = constate(useUserPreferencesState);

export function useThemeMode() {
  return useUserPreferences();
}
